export const makeAxlePosition = (axle: string, position: string) => {
  return `${axle}:${position}`;
};
